<template>
  <div class="footer" :class="[hiddenFooter ? 'hidden' : '']">
    <div class="content">
      <div class="left">
        <img draggable="false" src="@/assets/img/Dreamraillogo.svg" class="logo" alt="dreamrail.cn" />
      </div>
      <div class="right">
        <div class="icons">
          <a class="l1" href="https://www.xiaohongshu.com/user/profile/600996c5000000000101f3d3" target="_blank" rel="noopener noreferrer">
            <img src="https://file2.dreamrail.cn/resources/xiaohongshu.png" alt="小红书" />
          </a>
          <a class="l2" href="https://weibo.com/u/6436526037" target="_blank" rel="noopener noreferrer">
            <img src="https://file2.dreamrail.cn/resources/%E5%BE%AE%E5%8D%9A.png" alt="微博" srcset="" />
          </a>
          <a class="l3" href="https://v.douyin.com/iSH32NFb/" target="_blank" rel="noopener noreferrer">
            <img src="https://file2.dreamrail.cn/resources/douyin.png" alt="抖音" srcset="" />
          </a>
          <a class="l4" href="https://www.instagram.com/dreamrail_official/profilecard/?igsh=MTVnY3VmNWhieDVmaA==" target="_blank" rel="noopener noreferrer">
            <img src="https://file2.dreamrail.cn/resources/instagram-fill.png" alt="instagram" srcset="" />
          </a>
        </div>
        <div class="r2">
          <span>©copyright 梦铁文化有限公司 {{ new Date().format("yyyy") }}</span>
          <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2024124456号</a>
          <a href=" " rel="noreferrer" target="_blank">苏公网安备32050502012301号</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {},
  computed: {
    hiddenFooter() {
      return this.$route.path === "/wallpaper/draw" || this.$route.path === "/wallpaper/drawSticker" || this.$route.path === "/wallpaper/drawCalendar" || this.$route.path === "/wallpaper/drawAvatar";
    },
    isHome() {
      return this.$route.path === "/";
    },
  },
  data() {
    return {};
  },
  methods: {
    goto(target) {
      window.open(target, "_blank");
    },
  },
};
</script>
<style scoped lang="less">
.footer {
  z-index: 1000;
  position: relative;
  background: #141414;
  width: 100%;
  &.hidden {
    display: none;
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 40px;
    max-width: 100%;
  }
  .left {
    .logo {
      width: 100px;
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 15px;
  }
  .icons {
    display: flex;
    align-items: center;
    gap: 17px;
    a {
      height: 17px;
      img {
        height: 17px;
        width: auto;
        object-fit: contain;
      }
    }
  }
  .r2 {
    display: flex;
    align-items: center;
    gap: 15px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 12px;
    span {
    }
    a {
      text-decoration: none;
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
@media screen and (max-width: 768px) {
  .footer {
    display: none;
  }
}
</style>
